export const USER = {
  get: "/me",
  login: "/login",
  loginOtp: "/login/otp",
  register: "/register",
  registerCheck: "/register-check",
  changePassword: "/change-password",
  refresh: "/regen-token",
  user: "/user",
  image: "/user/image",
  registerPush: "/register-push",
};
